import React, { Component } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import './FrontPage.css';
import FullbleedHero from '../components/ContentBlocks/FullbleedHero';
import { fetchFront/*, fetchInstagram*/ } from '../redux/actions';
import { connect } from 'react-redux';
import Loader from '../components/Loader';
import Helmet from 'react-helmet';
import ReactMarkdown from 'react-markdown';
import slug from 'slug';
import { HashLink as Link } from 'react-router-hash-link';

class FrontPage extends Component {

  componentDidMount() {
    if (!this.props.headField||!this.props.liftField) {
      this.props.fetchFront(this.props.intl.locale, this.props.date);
    }
    // fetch instagram data
  /*  if(!this.props.instagrams.length)
    {
      this.props.fetchInstagram();
    }*/
  }

  render() {
    return (
      <div className="front">
        <div>
          <Helmet title="W Restaurants" titleTemplate="%s" />
          {!this.props.headField && <Loader/>}
          {this.props.headField && <FullbleedHero fields={this.props.headField}/>}
          {this.props.lifts &&
            <div className="restaurants-grid">
              <div>
                {this.props.lifts.map((restaurant, i) => (
                  <div className={(i===0)?'col-1':'col-1'} key={restaurant.sys.id}>
                    <Link to={`/ravintolat#${slug(restaurant.fields.title.toLowerCase())}`} className={`restaurant restaurant${i} ${slug(restaurant.fields.title.toLowerCase())}`} style={{backgroundImage: 'url('+(restaurant.fields.image.fields.file ? restaurant.fields.image.fields.file.url+'?fm=jpg&q=80' : '')+')'}}>
                      <h3>{restaurant.fields.title}</h3>
                      <ReactMarkdown source={restaurant.fields.description} />
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          }
        </div>
      </div>
    );
  }
}

FrontPage.propTypes = {
  intl: intlShape.isRequired,
}

const mapStateToProps = state => ({
  headField:state.front.header,
//  instagrams:state.instagrams,
  date:state.date,
  lifts:state.front.lifts
});

const mapDispatchToProps = {
  fetchFront/*,
  fetchInstagram*/
};

export default connect(mapStateToProps,mapDispatchToProps)(injectIntl(FrontPage));



// WEBPACK FOOTER //
// ./src/containers/FrontPage.js